import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "clearfix" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h3", { class: "mt-0 mb-4" }, "Edition Configuration", -1 /* HOISTED */);
const _hoisted_3 = { class: "col-xs-12 col-sm-6 col-md-4 bottom10" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("label", null, "Edition", -1 /* HOISTED */);
const _hoisted_5 = { class: "col-xs-12 col-sm-6 col-md-4 bottom10" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", null, "Due Date", -1 /* HOISTED */);
const _hoisted_7 = { class: "input-group-append input-group-btn" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" }, null, -1 /* HOISTED */);
const _hoisted_9 = { class: "clearfix mt-4" };
const _hoisted_10 = { class: "col-xs-12 col-sm-12" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(),
                _createVNode(_component_multiselect, {
                    name: "editionId",
                    modelValue: _ctx.selectedEdition,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedEdition) = $event)),
                    "track-by": "value",
                    label: "text",
                    placeholder: _ctx.selectPlaceholder,
                    options: _ctx.allowedEditionOptions,
                    showLabels: false
                }, {
                    noResult: _withCtx(() => [
                        _createTextVNode("\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t")
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "placeholder", "options"])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode(),
                _createVNode(_component_b_input_group, { class: "clearfix bottom0" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_flat_pickr, {
                            class: "form-control",
                            modelValue: _ctx.companyEdition.dueDate,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.companyEdition.dueDate) = $event)),
                            config: _ctx.datePickerConfig,
                            placeholder: "Select due date"
                        }, null, 8 /* PROPS */, ["modelValue", "config"]),
                        _createTextVNode(),
                        _createVNode(_component_b_input_group_append, null, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_component_b_button, {
                                        type: "button",
                                        variant: "outline-secondary",
                                        "data-toggle": ""
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_8
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                })
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_b_button, {
                    type: "button",
                    variant: "primary",
                    onClick: _ctx.save,
                    disabled: _ctx.saving
                }, {
                    default: _withCtx(() => [
                        _hoisted_11,
                        _createTextVNode(" Save Edition\r\n\t\t\t")
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick", "disabled"])
            ])
        ]),
        _createTextVNode(),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.saving,
            message: "Saving..."
        }, null, 8 /* PROPS */, ["visible"])
    ], 64 /* STABLE_FRAGMENT */));
}
